<!--
 * @Descripttion: 相关应用
 * @Date: 2022-04-14
-->
<template>
  <div class="erelatedapp">
    <div class="erelatedapp-item" v-for="(item, index) in datas" :key="index">
      <img class="erelatedapp-item-icon" :src="item.logo" />
      <p class="erelatedapp-item-title">{{ item.title }}</p>
      <p class="erelatedapp-item-desc">{{ item.desc }}</p>
    </div>
  </div>
</template>

<script>
import { relatedappsEl , relatedappsTC} from '../datas';

export default {
  components: {},
  data() {
    return {
      datas: window.navigator.userAgent.toLocaleLowerCase().indexOf("eltravel") !== -1 ?relatedappsEl : relatedappsTC ,
    };
  },
  props: {},
  watch: {},
  computed: {},
  created() {
    window.document.title = '相关应用';
  },
  mounted() {
    if(this.$isTC || this.$isEL){
      _tc_bridge_util.set_webview_info({
      param: {
        webview: {
          immersionSwitch: '1',
        },
      },
      callback: (data) => {},
    });
    }
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.erelatedapp {
  overflow: hidden;
  position: relative;
  padding-bottom: 50px;
  &-item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    padding: 0 15px;
    &-icon {
      height: 60px;
      width: 60px;
      margin-top: 30px;
    }
    &-title {
      margin-top: 20px;
      color: #37383d;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: bold;
    }
    &-desc {
      margin-top: 20px;
      color: #37383d;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 22px;
    }
  }
}
</style>
